import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { AudioSourceType } from 'APP/constants/app';
import { mainCallModel, callModel } from 'APP/model/model';
import Entities from 'STORE';
import { MainCall } from 'STORE/Calls/MainCall/MainCall';
import { Group } from 'STORE/Groups/Group';

export const startSharedCallAndCreateGroup = async (): Promise<Group | null> => {
  if (Entities.Calls.ongoingCall || Entities.ActiveStream.hasStream) {
    Tasks.app.showAlert(t('calls_join_another_call'));
    return null;
  }

  const hasAudioPermissions = await Tasks.permissions.hasAudioPermissions();

  if (!hasAudioPermissions) {
    return null;
  }

  Tasks.app.audioSource.setCurrentSource(AudioSourceType.Call);
  const date = new Date();
  const callId = String(date.getTime());
  const providerType = Entities.Calls.callsProvider;

  const call = new MainCall({
    myId: Entities.usersStore.Me.id,
    calls: Entities.Calls,
    groupId: callId,
    channelId: null,
    providerType,
    withoutTimer: true,
    initialMedia: {
      withAudio: false,
      withVideo: false,
    },
    initialDevicesIds: {
      audiooutput: null,
      audioinput: null,
      videoinput: null,
    },
  });

  Entities.Calls.add(call);

  try {
    const callCreatedInfo = await mainCallModel.createCall({
      groupId: null,
      providerType,
    });

    if (!callCreatedInfo) {
      return null;
    }
    const response = await callModel.getCallInfo({
      channelId: callCreatedInfo.channelId,
      providerType: call.providerType,
    });
    const { groupId } = response;

    if (groupId) {
      await Tasks.group.loadNewCallGroup(groupId);
    }

    call.setReadyToStart({ callInfo: response, isInitiator: true });

    return null;
  } catch (e) {
    Entities.Calls.delete(call.groupId, call.channelId);

    Tasks.app.showAlert(t('calls_connection_error'));

    return null;
  }
};
